<template lang="html">

  <section class="pe_game">
    <GameMenu />

    <div class="pe_container">

      <div class="pe_game-wrap">
        <Grid 
          type="trivia" 
        />
      </div>

    </div>

    <transition name="delay">


      <div class="pe_completedmodal_container" v-if="completed">
        <div class="pe_completedmodal_close-button"></div>
        <div class="pe_completedmodal_main-content">
          <div class="pe_completedmodal_row pe_logo"><Trophy /></div>
          <div class="pe_completedmodal_row"><h1>{{ congratsMessage(points) }}</h1></div>
          <div class="pe_completedmodal_row pe_mt_1" v-if="points"><strong></strong>Total points: {{ points }}</strong></div>
          <div class="pe_completedmodal_row pe_mt_1">Correct on first attempt: <strong>{{ correctOnFirst }}/{{ triviaData.length }}</strong></div>
          <div class="pe_completedmodal_row pe_cm_sub" v-if="points">Your best score: <strong>{{ triviaHiScore }}</strong></div>
          <div class="pe_completedmodal_row pe_cm_sub" v-if="points">Category best score: <strong>{{ triviaCatHiScore }}</strong></div>

          <div class="pe_completedmodal_row pe_mt_2">
            <router-link 
                    to="/"
                    class="pe_completedmodal_btn trivia"
                  > 
                    Main Menu
            </router-link>
          </div>

        </div>
      </div>

    </transition>

  </section>

</template>

<script lang="js">

  import { mapActions, mapState } from 'vuex'

  import Grid from '@puzzleapps/trivia/src/components/Grid'
  import GameMenu from '@puzzleapps/shared/src/components/ui/GameMenu'
  import CompletedModal from '@puzzleapps/shared/src/components/ui/CompletedModal'
  import Stopwatch from '@puzzleapps/shared/src/components/ui/StopWatch'
  import Trophy from '@puzzleapps/shared/src/components/ui/logos/Heart'
  import Heart from '@puzzleapps/shared/src/components/ui/logos/Heart'
  
  export default  {
    name: 'game',
    props: [],
    components: {
      Grid,
      CompletedModal,
      GameMenu,
      Trophy,
      Stopwatch,
      Heart
    },

    mounted() {
      this.selectThemeFromLocal()
    },

    destroyed() {
      this.setIsPlaying(false)
    },

    methods: {
      ...mapActions({
        setIsPlaying: 'game/setIsPlaying',
        selectThemeFromLocal: 'userSettings/selectThemeFromLocal',
      }),
      congratsMessage(score){
        if(score > 999)
          return "WOW, you're a genius!";
        
        if(score > 899)
          return "Wow, fantastic result!";

        if(score > 799)
          return "Great result!";

        if(score < 800)
          return "Good result!";
      },
    },

    computed: {
      ...mapState({
        triviaData: state => state.grid.triviaData,
        completed: state => state.game.completed,
        points: state => state.game.points,
        correctOnFirst: state => state.game.correctOnFirst,
        triviaHiScore: state => state.game.triviaHiScore,
        triviaCatHiScore: state => state.game.triviaCatHiScore,
      }),

    },

}


</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/gameContainer';
  @import '@puzzleapps/shared/src/style/completedModal2';

  #puzzleapp.pe_trivia {
    margin-top: 3%;
    .pe_game {

      .pe_game-menu {
        color:#fff;
        background-color: #222222;
        border-bottom-color: #fff;
        border-bottom-width: 1px;
      }

      .pe_container {
        max-width: $max-container-size;
        background-size: cover;
        background-color: #222222;

        @media (max-width: 768px) {
          flex-direction: column;
              min-height: 36em;
        }

        .pe_game-wrap {
          min-height: 500px;
          box-sizing: border-box;
          justify-content: center;
          display: flex;
          margin-top: 2%;

          @media (max-width: 768px) {
            width: 100%;
            // max-width: 500px;
            margin: 0 auto 2rem;
            padding: 0;
            // height: 100vh;
          }
        }
      }
    }
  }

</style>
